import { useCallback, useContext, useEffect, useState } from 'react'
import { WalletAddressContext } from '@/lib/walletContext'
import { getWatchlist, toggleWatch, WATCHLIST_EVENT } from '@/lib/watchlist'

export function useWatchlist() {
  const address = useContext(WalletAddressContext)
  const [ids, setIds] = useState<string[]>(() => getWatchlist(address))

  useEffect(() => {
    const sync = () => setIds(getWatchlist(address))
    sync()
    window.addEventListener(WATCHLIST_EVENT, sync)
    window.addEventListener('storage', sync)
    return () => {
      window.removeEventListener(WATCHLIST_EVENT, sync)
      window.removeEventListener('storage', sync)
    }
  }, [address])

  const toggle = useCallback((projectId: string) => {
    toggleWatch(projectId, address)
  }, [address])

  const isWatched = useCallback((projectId: string) => ids.includes(projectId), [ids])

  return {
    ids,
    isWatched,
    toggle,
    address,
  }
}
